
    // IMPORTS
    import { defineComponent, computed, PropType } from 'vue'
    import { useAddressStore } from '@/store/address'

    import InputDropdown from './input-dropdown.vue'

    import { buildLocalization } from '@/util'
    
    export default defineComponent({
        name: 'countrySelector',

        components: {
            InputDropdown
        },

        props: {
            id: { type: String as PropType<string>, required: true },
            modelValue: { type: String as PropType<string>, required: true },
            width: { type: Number as PropType<number | null>, required: false, default: () => null }
        },

        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            'update:modelValue': (value: string) => true,
        },

        setup(props, { emit }) {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const addressStore = useAddressStore()

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const { currentLanguage } = buildLocalization()
            const allCountries = computed(() => addressStore.getCountryNames(currentLanguage.value).sortBy(c => c.name))

            const computedData = { allCountries }

            /********************************************************************************************************************
             PUBLIC METHODS AND EVENT HANDLERS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            function onChange(value: string) {
                emit('update:modelValue', value)
            }

            const publicMethods = { localize, onChange }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...computedData, ...publicMethods }
        }
    });
